// src/Components/Sidebar.js
import React, { useState, useEffect } from "react";
import { ListGroup, ListGroupItem, Collapse, Modal, ModalBody, Button } from "reactstrap";
import { Link, useNavigate  } from 'react-router-dom';
import logo from '../Assets/App_icon/logo.png';
import logout from '../Assets/App_icon/logout.png';
import gmaplogo from '../Assets/App_icon/gmap.png';


const Sidebar = () => {
  const navigate = useNavigate();
  const [openSection, setOpenSection] = useState(""); 
  const [childOpenSection, setChildOpenSection] = useState(""); 

  const username = localStorage.getItem('username');
  const cityname = localStorage.getItem('cityname');
  const userRole = localStorage.getItem('userRole');
 
  const [mobileNumber, setMobileNumber] = useState('');
  const [custDetail, setCustDetail] = useState(null);
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [selectedOrderDetail, setSelectedOrderDetail] = useState([]);
  const [ledgerData, setLedgerData] = useState([]);
  const [selectedLedgerData, setSelectedLedgerData] = useState([]);
  const [selectedSalesDetail, setSelectedSalesDetail] = useState([]);

  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');
  const [modalVisible, setModalVisible] = useState(false);
  const [ledgerModalVisible, setLedgerModalVisible] = useState(false); 
  const [salesDetailModalVisible, setSalesDetailModalVisible] = useState(false); 


  useEffect(() => { 
    if (mobileNumber.length == 10 && /^[0-9]*$/.test(mobileNumber)){
      const fetchCustDetail = async () => { 
        try {
          const response = await fetch(`${host_url}/cust_select`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              lang: 'Gujarati',
              store: store,
              custMo: mobileNumber,
            }),
          });            
          const data = await response.json();
          if(data.error) {
            alert(data.error);
          } else {
            if(data.length > 0){
              const cust = data[0];
              setCustDetail(cust);
              setMobileNumber('');  
              setModalVisible(true);   
              fetchOrderList(cust.custId)         
            }
          }
        } catch (error) {
          console.error('Error fetching categories:', error);
        }
      }; 
     fetchCustDetail();  
    } 

    
  }, [mobileNumber]); // Customer Detail


  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('store');
    localStorage.removeItem('cityname');
    localStorage.removeItem('userid');
    localStorage.removeItem('username');
    localStorage.removeItem('userRole'); 
    navigate('/'); 
  };


  const handleCustLedger = async (custId) => {
   
    setLedgerModalVisible(true);
    try {
      const response = await fetch(`${host_url}/cust_ledger`, {
      method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          custId: custId,
          lang: 'Gujarati',
          store: store
        }),
      });

      const data = await response.json();
      setLedgerData(data);
      console.log(data);
    } catch (error) {
      console.error('Error updating profile:', error);
    }
  };

  const handleSalesDetail = async (sale) => {

    setSalesDetailModalVisible(true);
    setLedgerModalVisible(false);
    setSelectedSalesDetail([]);
    setSelectedLedgerData(sale);
    const salesDetail = {
          sl_id: sale.tr_id,
      };
    try {
      const response = await fetch(`${host_url}/sales_select`, {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: 'list', 
          store: store, 
          salesdetail: salesDetail,  
        }),
      });
      const data = await response.json();
      setSelectedSalesDetail(data);
      console.log("selectedSalesDetail", data);
    } catch (error) {
      console.error('Error fetching cities:', error);
    }  
  };

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? "" : section));
    setChildOpenSection((prev) => (prev === "" ));
  };
  const childToggleSection = (childsection) => {
    setChildOpenSection((prev) => (prev === childsection ? "" : childsection));
  };

  const fetchOrderList = async (custId) => { 
    try {
      const response = await fetch(`${host_url}/order_mlist`, {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: 'cust_wise',
          store: store,
          custId: custId,
        }),
      });
      const data = await response.json();

         const ordersWithTime = data.map(order => {
            const utcDate = new Date(order.ordDate);
            const datePlus11 = new Date(utcDate.getTime() + 11 * 60 * 60 * 1000);

            const day = String(utcDate.getDate()).padStart(2, '0');
            const month = String(utcDate.getMonth() + 1).padStart(2, '0');
            const year = utcDate.getFullYear();

            const hours = datePlus11.getUTCHours().toString().padStart(2, '0');
            const minutes = datePlus11.getUTCMinutes().toString().padStart(2, '0');

            return {
              ...order,
              ordTime: `${hours}:${minutes}`,
              ordLDate: `${day}-${month}-${year}`,
            };
          });

      setOrders(data);
      console.log(ordersWithTime);
    } catch (error) {
      console.error('Error fetching cities:', error);
    }    
  }; 


  return (
    <div className="sidebar">
      {/* Logo Header */}
        <div className="sidebar_header">
            <Link to="/app/dashboard" style={{ textDecoration: 'none' }}>
              <img  className="logo-image" src={logo} alt="VeryFresh"/>
            </Link>
        </div>   


      {/* Menu Sections */}
        <div className="sidebar_middle">
          <ListGroup flush>

            {/* Cust Detail Search Section */}
                  <input
                    type="text"
                    id="mobileNumber"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    placeholder="Mobile Number"
                    maxLength="10"  

                    onFocus={(e) => (e.target.style.border = "1px solid #4CAF50")}
                    onBlur={(e) => (e.target.style.border = "1px solid #ccc")}
                    style={{
                      width: "90%",
                      padding: "6px 10px",
                      fontSize: "14px",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      outline: "none",
                      margin: "8px 10px",
                      height: "25px",
                      boxSizing: "border-box"
                    }}
                  />    

            {/* Transaction Section */}
              <div className="divider" onClick={() => toggleSection("transaction")}>Transaction </div>
              <Collapse isOpen={openSection === "transaction"}>
                  <Link to="/app/Trans_order" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Order</ListGroupItem>
                  </Link>
                  <Link to="/app/Trans_packing" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Packing</ListGroupItem>
                  </Link>
                  <Link to="/app/Master_delman" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Deliveryman</ListGroupItem>
                  </Link>
                  <Link to="/app/Trans_cash_entry" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Cash Entry</ListGroupItem>
                  </Link>
                  <Link to="/app/Trans_purchase" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Purchase</ListGroupItem>
                  </Link>
                  <Link to="/app/Trans_wasteg" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Wasteg</ListGroupItem>
                  </Link>                 
              </Collapse>

            {/* Delivery Partner Section */}
              <div className="divider" onClick={() => toggleSection("delpartner")}>Del Partner </div>
              <Collapse isOpen={openSection === "delpartner"}>
                  
                  <Link to="/app/Trans_order" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Collection</ListGroupItem>
                  </Link>
                  <Link to="/app/Trans_packing" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Del Master</ListGroupItem>
                  </Link>
                  <Link to="/app/Master_delman" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Del Shift</ListGroupItem>
                  </Link>
               
              </Collapse>  

            {/* Product Section */}
              <div className="divider" onClick={() => toggleSection("product")}>Product</div>
              <Collapse isOpen={openSection === "product"}>
                <Link to="/app/Master_product" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Product</ListGroupItem>
                </Link>
                <Link to="/app/Master_category" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Category</ListGroupItem>
                </Link>
                <Link to="/app/Acc_hsncode" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">HSN Code</ListGroupItem>
                </Link>
              </Collapse>

            {/* Master Section */}
              <div className="divider" onClick={() => toggleSection("master")}>Master</div>
              <Collapse isOpen={openSection === "master"}>
                <Link to="/app/Master_customer" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Customer</ListGroupItem>
                </Link>
                <Link to="/app/Master_area" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Area</ListGroupItem>
                </Link>
                <Link to="/app/Master_users" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Users</ListGroupItem>
                </Link>
                 <Link to="/app/Master_welcome_image" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Welcome Image</ListGroupItem>
                </Link>
                
                {userRole === 'Admin' && (
                  <Link to="/app/Master_wapi_login" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Whatsapp</ListGroupItem>
                  </Link>
                )}
              </Collapse>

            {/* Report Section */}
              <div className="divider" onClick={() => toggleSection("report")}>Report </div>
              <Collapse isOpen={openSection === "report"}>
                  <div className="subdivider" onClick={() => childToggleSection("Order")}>Order</div>
                    <Collapse isOpen={childOpenSection === "Order"}>
                        <Link to="/app/Report_ord_prd" style={{ textDecoration: 'none' }}>
                          <ListGroupItem className="childMenuItem">Product wise</ListGroupItem>
                        </Link>
                    </Collapse> 
                  <div className="subdivider" onClick={() => childToggleSection("sales")}>Sales</div>
                    <Collapse isOpen={childOpenSection === "sales"}>
                        <Link to="/app/Trans_sales" style={{ textDecoration: 'none' }}>
                          <ListGroupItem className="childMenuItem">Sales Master</ListGroupItem>
                        </Link>
                    </Collapse> 
                  <div className="subdivider" onClick={() => childToggleSection("stock")}>Stock</div>
                    <Collapse isOpen={childOpenSection === "stock"}>
                        <Link to="/app/Report_stock" style={{ textDecoration: 'none' }}>
                          <ListGroupItem className="childMenuItem">Stock Report</ListGroupItem>
                        </Link>
                    </Collapse>  

                  <div className="subdivider" onClick={() => childToggleSection("PL")}>PL</div>
                    <Collapse isOpen={childOpenSection === "PL"}>
                        <Link to="/app/Report_PL" style={{ textDecoration: 'none' }}>
                          <ListGroupItem className="childMenuItem">PL Report</ListGroupItem>
                        </Link>
                    </Collapse>     
              </Collapse>

            {/* Account Section */}
              <div className="divider" onClick={() => toggleSection("account")}>Account</div>
              <Collapse isOpen={openSection === "account"}>
                <Link to="/app/Acc_accparty" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Account</ListGroupItem>
                </Link>
                <Link to="/app/Acc_expence" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Expence</ListGroupItem>
                </Link>
              </Collapse>

            {/* Marketing Section */}
              <div className="divider" onClick={() => toggleSection("notification")}>Marketing</div>
              <Collapse isOpen={openSection === "notification"}>
                <Link to="/app/Mkt_notification" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Notification</ListGroupItem>
                </Link>
              </Collapse>  

            {/* Utility Section */}
              <div className="divider" onClick={() => toggleSection("utility")}>Utility</div>
              <Collapse isOpen={openSection === "utility"}>
                <Link to="/app/StikerPrint" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Stiker Print</ListGroupItem>
                </Link>
              </Collapse>     
          </ListGroup>
        </div>  


      {/* Logout Footer */}
        <div className="sidebar_footer">
           <div style={{ textDecoration: 'none',  display: 'flex'  }}>
              <div onClick={handleLogout} className="sidebar_footer_lougout_image" >
                <img  className="icon-image" src={logout} alt="Logout"/>
              </div>
              <div className="sidebar_footer_user_detail" >
                <p style={{ marginLeft: '5px', fontSize: '12px' }}> {username} <br /> {cityname} </p>
              </div>
              
              
            </div>
        </div>

   

      {/* Modal for Order List */}
        <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
          <ModalBody style={{ backgroundColor: '#e8fadb'}}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ width: "20%" }}></div>
              <div style={{ width: "60%" }}>
                <h5 >Customer Detail</h5> 
              </div>
              <div style={{ width: "20%" }}>
                <Button color="primary" style={{ padding: '2px', margin: '2px' }} onClick={() => setModalVisible(false)}>Close</Button>
              </div>          
            </div>
            
                
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '48%', marginRight: '2%', border: '2px solid #dcdcdc'}}>
                <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th colSpan='2' className="cell-center" style={{ padding: '2px' }} >Date</th>
                      <th className="cell-left" style={{ padding: '2px', paddingRight: '10px', }} >Time</th>
                      <th className="cell-right" style={{ padding: '2px', paddingRight: '10px', }} >Amount</th>
                      <th colSpan='3' className="cell-center" style={{ padding: '2px' }} >Status</th>
                    </tr>
                  </thead>
                  <tbody className="scrollable-body">
                    {orders.map((row, index) => {
                      return (
                        <tr
                          key={index}
                          style={{ cursor: "pointer" }}
                          onClick={() => { setModalVisible(false); navigate("/app/Trans_order") }} 
                        >
                          <td colSpan='2' className="cell-center" style={{ padding: '2px' }} >
                            {
                              new Date(row.ordDate).toLocaleDateString('en-GB', {
                                timeZone: 'Asia/Kolkata'
                              }).replace(/\//g, '-')
                            }
                          </td>
                          <td className="cell-left" style={{ padding: '2px' }} >{row.ordTime}</td>
                          <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', }} >{row.ordAmt}</td>
                          <td colSpan='3' className="cell-center" style={{ padding: '2px' }} >
                                <span style={{ fontWeight: 'bold', fontSize: '13px',
                                                color: row.ordStatus === 'Ready For Delivery' ? 'green' :
                                                       row.ordStatus === 'Out For Delivery' ? 'red' :
                                                       row.ordStatus === 'Packing' ? 'orange' : 'black' 
                                              }}
                                >{row.ordStatus}</span>
                          </td>
                        </tr>
                      )}
                    )}        
                  </tbody>
                  <tfoot>
                      <tr>
                        <th colSpan="2" className="cell-center" style={{ padding: "2px" }}></th>
                        <th className="cell-left" style={{ padding: '2px', paddingRight: '10px' }} ></th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} ></th>
                        <th colSpan='3' className="cell-center" style={{ padding: '2px' }} ></th>
                      </tr> 
                  </tfoot>
                </table>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '50%', border: '2px solid #dcdcdc'}}>
                {custDetail && (
                  <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>
                      <tr>
                        <td className="cell-left" style={{ width: '25%'}} >{custDetail.custId} </td>
                        <td className="cell-left" style={{ width: '75%', cursor: 'pointer' }}  >{custDetail.custName}</td>
                      </tr>
                      <tr>
                        <td className="cell-left">Mo No :</td>
                        <td className="cell-left"> 
                              <a 
                                href={`whatsapp://send?phone=91${custDetail?.custMo}`} 
                                style={{ textDecoration: "none", color: "inherit" }}
                              >
                                {custDetail?.custMo}
                              </a> 
                        </td>
                      </tr>
                      <tr>
                        <td className="cell-left">
                          {custDetail?.custLocation ? (
                            <a
                              href={`https://www.google.com/maps?q=${custDetail.custLocation.y},${custDetail.custLocation.x}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ cursor: "pointer" }}
                            >
                              <img 
                                src={gmaplogo}   // your google map image
                                alt="Map" 
                                style={{ width: "20px", height: "20px" }} 
                              />
                            </a>
                          ) : (
                            "Add :"
                          )}
                        </td>
                        <td className="cell-left">{custDetail?.custAdd}</td>
                      </tr>
                       <tr>
                        <td className="cell-left">Area :</td>
                        <td className="cell-left">{custDetail?.custAreaEName}</td>
                      </tr>
                      <tr>
                        <td className="cell-left">Balance :</td>
                        <td className="cell-left" > <span  style={{ color: Number(custDetail?.custBalance) < 0 ? 'red' : 'inherit', cursor: "pointer" }} onClick={() => handleCustLedger(custDetail?.custId)}>{custDetail?.custBalance}</span></td>
                      </tr>
                      
                      <tr>
                        <td colSpan='2'>
                          
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </ModalBody>
        </Modal>  

      {/* Modal for Customer Ledger */}
            <Modal isOpen={ledgerModalVisible} toggle={() => setModalVisible(!ledgerModalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ padding: '2px' }} >Date</th>
                          <th style={{ padding: '2px' }} >Type</th>
                          <th style={{ padding: '2px' }} >Sales</th>
                          <th style={{ padding: '2px', paddingRight: '10px', }} >Pay</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {ledgerData.map((row, index) => {
                            return (
                              <tr key={index} >
                                <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{new Date(row.tr_date).toLocaleDateString("en-GB").replace(/\//g, "-")}</td>
                                <td className="cell-left" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >
                                    {row.tr_type === 'Cash_Back' ? (
                                      <span style={{color:'red'}}>{row.tr_type}</span>
                                    ) : (
                                        <span>{row.tr_type}</span>
                                    )}
                                </td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px'}}> <span style={{ cursor:'pointer'}} onClick={() => handleSalesDetail(row)} >{row.sl_amt === 0 ? '' : row.sl_amt}</span></td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.cr_amt === 0 ? '' : row.cr_amt}</td>
                              </tr>
                            );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan='2' className="cell-left"style={{ padding: '2px' }} >
                            <Button color="primary" style={{ padding: '2px', margin: '2px' }} onClick={() => setLedgerModalVisible(false)}>
                              Close
                            </Button>
                          </th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{ledgerData?.reduce((sum, ledger) => sum + (ledger.sl_amt || 0), 0)}</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{ledgerData?.reduce((sum, ledger) => sum + (ledger.cr_amt || 0), 0)}</th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
              </ModalBody>
            </Modal>        

      {/* Modal for Sales Detail */}
            <Modal isOpen={salesDetailModalVisible} toggle={() => setSalesDetailModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                  <h6>
                    {selectedOrder && `${selectedOrder.custName} - `}
                    {new Date(selectedLedgerData.tr_date)
                      .toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })
                      .replace(/\//g, "-")}
                  </h6>
                  <div>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th colSpan='3' className="cell-left" style={{ padding: '2px' }} >Item</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Qty</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Amount</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {selectedSalesDetail.map((row) => {
                            return (
                              <tr key={row.prd_id} style={{ cursor: 'pointer' }} >
                                <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.sd_prd_qty}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.sd_prd_amt}</td>
                              </tr>
                            );
                        })}
                      </tbody> 
                      <tfoot>
                        {(selectedLedgerData.sl_amt - (selectedSalesDetail.reduce((sum, item) => sum + item.sd_prd_amt, 0)) < 0) && (
                          <tr>
                            <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>Round off</td>
                            <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} ></td>
                            <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{selectedLedgerData.sl_amt - (selectedSalesDetail.reduce((sum, item) => sum + item.sd_prd_amt, 0))}</td>
                          </tr>
                        )}
                        <tr>
                          <th colSpan='3' className="cell-left"style={{ padding: '2px' }} >
                              <Button color="primary" style={{ padding: '2px', margin: '2px' }} onClick={() => {setSalesDetailModalVisible(false); setLedgerModalVisible(true);}}>
                                Close
                              </Button>
                          </th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }}>
                            {selectedSalesDetail
                              .reduce((sum, item) => sum + Number(item.sd_prd_qty || 0), 0)
                              .toFixed(3)}
                          </th>

                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }}>
                            {selectedSalesDetail
                              .reduce((sum, item) => sum + Number(item.sd_prd_amt || 0), 0)
                              .toFixed(0)}
                          </th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
              </ModalBody>
            </Modal>          

    </div>


  );
};

export default Sidebar;